<div
  echarts
  [options]="chartOptions()"
  (chartMouseOver)="onChartMouseOver($event)"
  (chartMouseOut)="onChartMouseOut($event)"
  class="scatter-plot-chart"
></div>
